import _defineProperty from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import addClass from 'dom-helpers/addClass';
import css from 'dom-helpers/css';
import qsa from 'dom-helpers/querySelectorAll';
import removeClass from 'dom-helpers/removeClass';
import ModalManager from '@restart/ui/ModalManager';
var Selector = {
  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
  STICKY_CONTENT: '.sticky-top',
  NAVBAR_TOGGLER: '.navbar-toggler'
};
var BootstrapModalManager = /*#__PURE__*/function (_ModalManager) {
  _inherits(BootstrapModalManager, _ModalManager);
  function BootstrapModalManager() {
    _classCallCheck(this, BootstrapModalManager);
    return _possibleConstructorReturn(this, _getPrototypeOf(BootstrapModalManager).apply(this, arguments));
  }
  _createClass(BootstrapModalManager, [{
    key: "adjustAndStore",
    value: function adjustAndStore(prop, element, adjust) {
      var actual = element.style[prop]; // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
      // @ts-ignore

      element.dataset[prop] = actual;
      css(element, _defineProperty({}, prop, "".concat(parseFloat(css(element, prop)) + adjust, "px")));
    }
  }, {
    key: "restore",
    value: function restore(prop, element) {
      var value = element.dataset[prop];
      if (value !== undefined) {
        delete element.dataset[prop];
        css(element, _defineProperty({}, prop, value));
      }
    }
  }, {
    key: "setContainerStyle",
    value: function setContainerStyle(containerState) {
      var _this = this;
      _get(_getPrototypeOf(BootstrapModalManager.prototype), "setContainerStyle", this).call(this, containerState);
      var container = this.getElement();
      addClass(container, 'modal-open');
      if (!containerState.scrollBarWidth) return;
      var paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
      var marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
      qsa(container, Selector.FIXED_CONTENT).forEach(function (el) {
        return _this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth);
      });
      qsa(container, Selector.STICKY_CONTENT).forEach(function (el) {
        return _this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth);
      });
      qsa(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
        return _this.adjustAndStore(marginProp, el, containerState.scrollBarWidth);
      });
    }
  }, {
    key: "removeContainerStyle",
    value: function removeContainerStyle(containerState) {
      var _this2 = this;
      _get(_getPrototypeOf(BootstrapModalManager.prototype), "removeContainerStyle", this).call(this, containerState);
      var container = this.getElement();
      removeClass(container, 'modal-open');
      var paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
      var marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
      qsa(container, Selector.FIXED_CONTENT).forEach(function (el) {
        return _this2.restore(paddingProp, el);
      });
      qsa(container, Selector.STICKY_CONTENT).forEach(function (el) {
        return _this2.restore(marginProp, el);
      });
      qsa(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
        return _this2.restore(marginProp, el);
      });
    }
  }]);
  return BootstrapModalManager;
}(ModalManager);
var sharedManager;
export function getSharedManager(options) {
  if (!sharedManager) sharedManager = new BootstrapModalManager(options);
  return sharedManager;
}
export default BootstrapModalManager;